import pptxgen from 'pptxgenjs';
import React from 'react';
import { connectToUser } from '../../User/containers/UserDataStore';
import { connectToTitles } from '../containers/TitlesDataStore';
import { Button } from 'antd';

export class TitleExportPowerpoint extends React.Component {
	render() {
		return <Button onClick={this.createPPT2}>PowerPoint</Button>;
	}

	createPPT2 = () => {
		const { titles } = this.props.titlesDataStore.state;
		const { aspect } = this.props;

		let pptx = new pptxgen();

		var biblioStart = 3.7;
		var maxJacketWidth = 3.2;
		pptx.defineSlideMaster({
			title: 'Title_Slide',
			background: { color: 'FFFFFF' },
			objects: [
				{
					rect: {
						x: 0,
						y: 0,
						w: '100%',
						h: 0.75,
						fill: { color: 'F1F1F1' },
					},
				},
				{
					placeholder: {
						options: {
							name: 'title',
							x: 0.4,
							y: 0.1,
							w: 9.5,
							h: 0.65,
						},
						text: '{title}',
					},
				},
				{
					placeholder: {
						options: {
							name: 'biblio',
							type: 'body',
							x: biblioStart,
							y: 1,
							w: 5.7,
							h: 3,
						},
						text: '{biblio}',
					},
				},
			],
			slideNumber: { x: '1%', y: '95%', align: 'right', fontSize: 10 },
		});

		titles &&
			titles.length > 0 &&
			titles
				.filter(t => aspect.some(asp => asp.sku === t.sku))
				.map((title, idx) => {
					let slide = pptx.addSlide({ masterName: 'Title_Slide' });

					const aspectRatio = aspect.filter(
						asp => asp.sku === title.sku,
					)[0].ratio;
					var jacketHeight = 4.3;
					var jacketWidth = jacketHeight * aspectRatio;
					jacketWidth =
						jacketWidth > maxJacketWidth
							? maxJacketWidth
							: jacketWidth;
					jacketHeight =
						jacketWidth === maxJacketWidth
							? maxJacketWidth / aspectRatio
							: jacketHeight;

					const titleUri =
						title &&
						title.images &&
						title.images.filter(im => im.type === 'jacketCover')
							.length > 0 &&
						title.images.filter(im => im.type === 'jacketCover')[0]
							.uri;

					const url = new URL(titleUri);
					const proxyurl = `${process.env.REACT_APP_API_URL}/jacketcovers`;

					slide.addText(title.name, {
						placeholder: 'title',
						bold: true,
					});
					slide.addText(
						[
							{
								text: title.author,
								options: {
									breakLine: true,
									bold: true,
									fontSize: 20,
								},
							},
							{
								text: title.supplier + ' • ',
								options: { fontSize: 16 },
							},
							{
								text: this.renderFrontListBackList(
									title.pubDate,
								),
								options: { bold: true, fontSize: 16 },
							},
							{
								text: ' | ' + this.getDate(title.pubDate),
								options: { breakLine: true, fontSize: 16 },
							},
							{
								text: title.format + ' • ',
								options: { fontSize: 16 },
							},
							{
								text: title.formattedPrices,
								options: { breakLine: true, fontSize: 16 },
							},
							{
								text: title.ean + ' • ',
								options: { fontSize: 16 },
							},
							{
								text: title.pages + ' pages',
								options: { breakLine: true, fontSize: 16 },
							},
							{
								text: title.measurements,
								options: { breakLine: true, fontSize: 16 },
							},
							{
								text: title.category,
								options: { fontSize: 16 },
							},
						],
						{ placeholder: 'biblio' },
					);
					slide.addImage({
						path: proxyurl + url.pathname,
						x: 0.4,
						y: 1,
						w: jacketWidth,
						h: jacketHeight,
						sizing: { type: 'crop', h: 4.3 },
					});
				});

		pptx.writeFile();
	};

	renderFrontListBackList = pubDate => {
		if (new Date(pubDate) > new Date()) {
			return 'FRONTLIST';
		} else {
			return 'BACKLIST';
		}
	};

	getDate = dateString => {
		const options = { year: 'numeric', month: 'long', day: 'numeric' };
		return new Date(dateString).toLocaleDateString(
			this.getCultureIndicator(this.props.userDataStore),
			options,
		);
	};

	getCultureIndicator(userDataStore) {
		const country = userDataStore.state.organization
			? userDataStore.state.organization.address.country
			: 'US';
		if (country == 'UK' || country == 'GB') {
			return 'en-GB';
		} else {
			return 'en-US';
		}
	}
}

export default connectToUser(connectToTitles(TitleExportPowerpoint));
